import getBorderFocusStyles from '../../../teams/getBorderFocusStyles';
var alertStyles = {
  dismissAction: function dismissAction(_ref) {
    var v = _ref.variables,
        p = _ref.props,
        siteVariables = _ref.theme.siteVariables;
    return {
      ':focus-visible': {
        backgroundColor: v.focusBackgroundColor,
        ':hover': {
          backgroundColor: v.hoverBackgroundColor
        }
      },
      ':hover': Object.assign({
        backgroundColor: v.hoverBackgroundColor
      }, getBorderFocusStyles({
        siteVariables: siteVariables
      })[':focus-visible'])
    };
  }
};
export default alertStyles;